
export default function ServicesSection() {
  const services = [
    {
      id: 1,
      title: 'タレントマネジメント',
      category: 'マネジメント',
      description: 'スケジュール管理から案件交渉まで、タレント活動を全面的にサポートします',
      icon: 'ri-user-star-fill',
      color: 'from-pink-500 to-rose-500',
    },
    {
      id: 2,
      title: 'キャラクターデザイン',
      category: 'デザイン',
      description: 'プロのイラストレーターによるオリジナルキャラクター制作・Live2Dモデリング',
      icon: 'ri-palette-fill',
      color: 'from-cyan-500 to-teal-500',
    },
    {
      id: 3,
      title: '配信サポート',
      category: 'テクニカル',
      description: '高品質な配信環境の提供、OBS設定、サムネイル制作などをサポート',
      icon: 'ri-live-fill',
      color: 'from-violet-500 to-purple-500',
    },
    {
      id: 4,
      title: 'プロモーション',
      category: 'マーケティング',
      description: 'SNS運用、コラボ企画、イベント出演など、認知度向上を支援',
      icon: 'ri-megaphone-fill',
      color: 'from-amber-500 to-orange-500',
    },
    {
      id: 5,
      title: '楽曲制作',
      category: 'ミュージック',
      description: 'オリジナル楽曲の制作、歌ってみた動画のMIX・マスタリング',
      icon: 'ri-music-2-fill',
      color: 'from-pink-500 to-cyan-500',
    },
    {
      id: 6,
      title: 'グッズ展開',
      category: 'マーチャンダイズ',
      description: 'オリジナルグッズの企画・制作・販売までトータルサポート',
      icon: 'ri-gift-fill',
      color: 'from-emerald-500 to-teal-500',
    },
  ];

  return (
    <section id="services" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block bg-gradient-to-r from-pink-100 to-cyan-100 rounded-full px-6 py-2 mb-4">
            <span className="text-sm font-bold text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-cyan-500">SERVICES</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            充実の<span className="text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-cyan-500">サポート体制</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            VTuber活動に必要なすべてをワンストップでサポートします
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service) => (
            <div
              key={service.id}
              className="group bg-white rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer border border-gray-100 hover:-translate-y-2"
            >
              <div className={`w-16 h-16 flex items-center justify-center bg-gradient-to-br ${service.color} rounded-2xl mb-6 group-hover:scale-110 transition-transform`}>
                <i className={`${service.icon} text-white text-2xl`}></i>
              </div>
              <div className="inline-block bg-gray-100 rounded-lg px-3 py-1.5 mb-3">
                <span className="text-xs font-bold text-gray-600">{service.category}</span>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {service.title}
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
